import { Expose } from 'class-transformer';

export class ServiceCategory {
  @Expose()
  public id: number;

  @Expose()
  public name: string;
}
